<script>
import HeadSticky from "./components//Head-sticky.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "layout-head",
  components: {HeadSticky},
  data() {
    return {
      condition: {
        keywords: null,
        activeName: 'home'
      },
    }
  },
  computed: {
    ...mapState('user', ['routerName',]),
  },
  created() {
    //this.condition.activeName = this.$route.name || 'home';
  },
  // watch: {
  //   'condition.activeName': {
  //     handler(val) {
  //       this.hasLogin = !['login'].includes(val);
  //     }
  //   }
  // },
  methods: {
    handleClickRouter(e) {
      this.condition.activeName = 'login';
      this.$router.push(e);
    },
    ...mapActions('user', ['upDateRouterName',]),
  }
}
</script>

<template>
  <div class="layout-headBg">
    <HeadSticky ref="headSearch" :hasLogin="routerName !== 'login'"></HeadSticky>
  </div>
</template>

<style scoped lang="scss">
.layout-headBg {
  z-index: 1000;
  height: 60px;
  background: var(--background-head);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;

  &-shade{
    margin-top: -60px;
    width: 100%;
    height: 260px;
    background: linear-gradient( 180deg, #4393F5 0%, rgba(67,147,245,0) 100%);
  }
}
</style>